import classNames from 'classnames';
import { withStore } from 'store';
import styles from './styles.module.scss';
import { COUPON_TEXT } from 'constants/values/coupons';
import { useWindowSize } from 'hooks';


const NOTE = COUPON_TEXT;

function GiftCoupon({
  variant = '',
  className = '',
  code = '',
  containerClassName = '',
  applyBonification = false
}) {
  const [, { isMobile }] = useWindowSize();
  const isBig = (isMobile? false : variant === 'big');

  let coupon = null;

  if(code.length) {
    coupon = (
      <div className={styles.cuadrocoupon} >
        <div className={classNames(styles.label, isBig && styles.labelBig)}>
          <center><b>Regalo de bienvenida </b><font color="red"><i className="fa fa-gift fa-1x "/></font></center>
        </div>
        <article className={`${styles.couponContainer} ${containerClassName}`}>
          <div
            className={classNames(
              styles.coupon,
              isBig && styles.couponBig,
              className
            )}
          >
            <div className={classNames(styles.info, isBig && styles.infoBig)}>
              <span className={classNames(styles.code, isBig && styles.codeBig)}>
                {code}
              </span>
            </div>
          </div>
        </article>
      </div>

      /*
      <article className={`${styles.couponContainer} ${containerClassName}`}>
        <div
          className={classNames(
            styles.coupon,
            isBig && styles.couponBig,
            className
          )}
        >
          <div className={classNames(styles.info, isBig && styles.infoBig)}>
            <span className={classNames(styles.label, isBig && styles.labelBig)}>
              Regalo de bienvenida
            </span>
            <span className={classNames(styles.code, isBig && styles.codeBig)}>
              {code}
            </span>
          </div>
          <p className={styles.notes}>{NOTE}</p>
        </div>
      </article>
      */
    );
  }
  else if(applyBonification) {
    coupon = (
      <article className={`${styles.couponContainer} ${containerClassName}`}>
        <div
          className={classNames(
            styles.coupon,
            isBig && styles.couponBig,
            className
          )}
        >
          <p className={styles.notes}>Para tener tu cupón de regalo de Bienvenida, debes tener al menos $500 en regalos</p>
        </div>
      </article>
    );
  }

  return coupon;
}

export default withStore({
  mapStateToProps: (state) => ({
    code: state.giftTable.giftTableInfo.data.coupon || '',
    applyBonification: state.giftTable.giftTableInfo.data.applyBonification || false,
  }),
})(GiftCoupon);
